import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { SaveTipoInstalacion } from '../../shared/components';

export interface CreateTipoInstalacionPageInterface {}

const CreateTipoInstalacionPage: React.FC<
  CreateTipoInstalacionPageInterface
> = () => {
  useCheckPermissions(PermissionsEnum.api_add_instalacion);

  return <SaveTipoInstalacion titlePage="Crear Tipo de Instalación" />;
};

export default CreateTipoInstalacionPage;
